import { actFormFields } from '../../../containers/ActForm/constants';
import HOSPITAL_ACTIVITY_AREA_MAP from '../../../../shared/ramq/domainValues/activityAreas';
import { Act } from 'shared/medyx-core/types/act';

const ERROR_MESSAGE =
  "Le code 20176 peut être facturé seulement dans le secteur d'activité externe ou bien en cabinet privé.";

const code20176ExternalClinicOrCabinetValidation = (act: Act) => {
  if (!act.codes?.some(({ code }) => code === '20176')) return {};

  const isExternalClinic = act.activityArea === HOSPITAL_ACTIVITY_AREA_MAP.externalClinic;
  const isPrivateCabinet = act.place?.isCabinet === true;

  if (isExternalClinic || isPrivateCabinet) return {};

  return {
    [actFormFields.codes]: {
      _error: ERROR_MESSAGE
    }
  };
};

export default code20176ExternalClinicOrCabinetValidation;
